import { useState } from 'react';
import dayjs from 'dayjs';
import { GetYesterdayDate } from '../../../../utils/helpers';

const useSearchState = () => {
  const [date, setDate] = useState(dayjs(GetYesterdayDate()));
  const [route, setRoute] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(false);

  const resetSearch = () => {
    setRoute('');
    setDate(dayjs(GetYesterdayDate()));
    setSearchInput('');
  };

  return {
    date,
    setDate,
    route,
    setRoute,
    searchInput,
    setSearchInput,
    loading,
    setLoading,
    resetSearch,
  };
};

export default useSearchState;
